import React from "react";
import {
  Modal,
  Pressable,
  StyleSheet,
  Text,
  View,
  useWindowDimensions,
} from "react-native";
import { Ionicons } from "@expo/vector-icons";

type Props = {
  visible: boolean;
  showAdminUsers: boolean;
  onClose: () => void;
  onPressAdminUsers: () => void;
  onPressAdminConversations: () => void;
  onPressAdminSignupFunnel: () => void;
  onPressProfile: () => void;
  onPressLogout: () => void;
};

const MOBILE_BREAKPOINT = 768;

export default function AppHeaderMenuModal({
  visible,
  showAdminUsers,
  onClose,
  onPressAdminUsers,
  onPressAdminConversations,
  onPressAdminSignupFunnel,
  onPressProfile,
  onPressLogout,
}: Props) {
  const { width } = useWindowDimensions();
  const isMobile = width < MOBILE_BREAKPOINT;

  return (
    <Modal
      animationType="none"
      transparent
      visible={visible}
      onRequestClose={onClose}
    >
      <Pressable
        style={[styles.backdrop, isMobile && styles.backdropMobile]}
        onPress={onClose}
      >
        <View
          style={[styles.menu, isMobile && styles.menuMobile]}
          onStartShouldSetResponder={() => true}
        >
          <Pressable style={styles.menuItem} onPress={onPressProfile}>
            <Ionicons name="person-circle-outline" size={18} color="#fff" />
            <Text style={styles.menuText}>My profile</Text>
          </Pressable>
          {showAdminUsers && (
            <>
              <View style={styles.divider} />
              <Pressable style={styles.menuItem} onPress={onPressAdminUsers}>
                <Ionicons name="mail-outline" size={18} color="#fff" />
                <Text style={styles.menuText}>User emails</Text>
              </Pressable>
              <View style={styles.divider} />
              <Pressable
                style={styles.menuItem}
                onPress={onPressAdminConversations}
              >
                <Ionicons name="stats-chart-outline" size={18} color="#fff" />
                <Text style={styles.menuText}>Conversation attendance</Text>
              </Pressable>
              <View style={styles.divider} />
              <Pressable
                style={styles.menuItem}
                onPress={onPressAdminSignupFunnel}
              >
                <Ionicons name="funnel-outline" size={18} color="#fff" />
                <Text style={styles.menuText}>Signup funnel</Text>
              </Pressable>
            </>
          )}
          <View style={styles.divider} />
          <Pressable
            style={styles.menuItem}
            onPress={onPressLogout}
            testID="header-menu-logout"
          >
            <Ionicons name="log-out-outline" size={18} color="#fff" />
            <Text style={styles.menuText}>Logout</Text>
          </Pressable>
        </View>
      </Pressable>
    </Modal>
  );
}

const styles = StyleSheet.create({
  backdrop: {
    flex: 1,
    backgroundColor: "transparent",
  },
  backdropMobile: {
    paddingHorizontal: 16,
    paddingTop: 72,
    paddingBottom: 16,
  },
  menu: {
    position: "absolute",
    right: 24,
    top: 72,
    minWidth: 210,
    backgroundColor: "#3a6fb1",
    borderRadius: 16,
    paddingVertical: 10,
    elevation: 8,
    shadowColor: "#000",
    shadowOpacity: 0.2,
    shadowRadius: 10,
    shadowOffset: { width: 0, height: 4 },
  },
  menuMobile: {
    position: "relative",
    right: 0,
    top: 0,
    minWidth: 0,
    width: "100%",
    flex: 1,
    borderRadius: 22,
    paddingVertical: 16,
  },
  menuItem: {
    flexDirection: "row",
    alignItems: "center",
    gap: 10,
    paddingHorizontal: 16,
    paddingVertical: 10,
  },
  menuText: {
    fontSize: 12,
    fontWeight: "700",
    color: "#fff",
    textTransform: "uppercase",
    letterSpacing: 0.6,
  },
  divider: {
    height: 1,
    marginHorizontal: 16,
    backgroundColor: "rgba(255, 255, 255, 0.35)",
  },
});
